import React, {useEffect,useState} from 'react'
import {fetchAllEvents, eventsSelector} from '../../api/events'
import {loginSelector} from '../../api/authSlice'
import {useDispatch, useSelector} from 'react-redux'
import Loader from '../../shared/loader'
import DataTable from './datatable'
import { Button } from 'antd'
import { Link } from 'react-router-dom'
import { Input  } from 'antd';
import { useDebounce } from "use-debounce";


export default function Events() {

  const dispatch = useDispatch()
  const {events } = useSelector(eventsSelector)
  const {filter} = useSelector(loginSelector)
  console.log(filter);
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(false)
  const [debouncedText] = useDebounce(search, 1000)

  console.log({events})

useEffect(()=>{
dispatch(fetchAllEvents())
}, [dispatch])

const { Search } = Input;




    return (<>
<div className="mb-4 float-right ">
    <div className="mx-3">

{/* <Search placeholder="Search Events" className="mx-3" style={{ width: 230 }} enterButton /> */}
    <Button type="primary" >
        <Link className=' text-white' to="/admin/create-events">Create Event</Link>
    </Button> 
</div>
</div>
{

 <DataTable loading={loading}
 data ={(filter.length> 0) ? filter : events}/>

}
    </>
       )
}  







